import { getClerk } from './clerk'

export async function apiFetch(input: RequestInfo, init: RequestInit = {}) {
  const options: RequestInit = { ...init, credentials: 'include' }

  try {
    const clerk = await getClerk()
    let token: string | null = null
    try {
      const isSignedIn = Boolean((clerk as any)?.isSignedIn)
      if (isSignedIn && typeof clerk.session?.getToken === 'function') {
        token = await clerk.session.getToken()
      }
    } catch (_) {
      // ignore
    }

    if (token) {
      const headers = new Headers(options.headers || undefined)
      headers.set('Authorization', `Bearer ${token}`)
      options.headers = headers
    }
  } catch (_) {
    // clerk not available — proceed without Authorization
  }

  return await fetch(input, options)
}

export default { apiFetch }
